import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ImagePathService {

  constructor() { }
  assetsPath: string = 'assets/images/';
  iconPath: string = 'dachneigung/';
  SENLogo: string = `${this.assetsPath}sen-logo.png`;
  loginPageBgImage: string = `${this.assetsPath}login_image.png`;
  loginSENLogo: string = `${this.assetsPath}soldraftlogo_login.png`;
  slidePlaceholder: string = `${this.assetsPath}senlogo-placeholder.jpg`;

  //menu icons
  manageIcon: string = `${this.assetsPath}menu_icon_manageproject.png`;
  projectIcon: string = `${this.assetsPath}menu_icon_projecty.png`;
  planIcon: string = `${this.assetsPath}menu_icon_plan.png`;
  inverterIcon: string = `${this.assetsPath}menu_icon_inverter.png`;
  settingsIcon: string = `${this.assetsPath}menu_icon_settings.png`;
  helpIcon: string = `${this.assetsPath}menu_icon_help.png`;

  //mounting icons

  SOL50_STAN_2M: string = `${this.assetsPath}onroof_standard1.jpg`;
  SOL50_PREM_2M: string = `${this.assetsPath}onroof_premium1.jpg`;
  SOL50_STAN: string = `${this.assetsPath}onroof_standard1.jpg`;
  SOL50_PREM: string = `${this.assetsPath}onroof_premium1.jpg`;
  SOL50I_PREM: string = `${this.assetsPath}inroof_premium1.jpg`;
  COLOR_PRESSBLANK: string = `${this.assetsPath}hp_millfinish1.jpg`;
  COLOR_BLACK: string = `${this.assetsPath}hp_black1.jpg`;
  ROOF_PANTILED: string = `${this.assetsPath}rt_pantiled.jpg`;
  ROOF_TRAPEZOIDAL: string = `${this.assetsPath}rt_trapezoidal.jpg`;
  ROOF_CORRUGATED: string = `${this.assetsPath}rt_corrugated.jpg`;
  ROOF_SLATED: string = `${this.assetsPath}rt_slated.jpg`;
  ROOF_PLAIN_TILED: string = `${this.assetsPath}rt_plain_tiled.jpg`;
  MOUNT_DIRECT: string = `${this.assetsPath}trapezoidal_direct.jpg`;
  CRISS_CROSS: string = `${this.assetsPath}trapezoidal_crisscross.jpg`;
  BATTEN_SPACED: string = `${this.assetsPath}batten.jpg`;
  BATTEN_PLANKING: string = `${this.assetsPath}planking.jpg`;
  SOL30_HP: string = `${this.assetsPath}sol30_hp.jpg`;

  //roofshape icons
  ORIENTATION_COMPASS: string = `${this.assetsPath}orientation_compass_bg.png`;
  ORIENTATION_ROOF: string = `${this.assetsPath}orientation_roof.png`;

  ROOFANGLE_20: string = `${this.assetsPath}${this.iconPath}Haus_20.png`;
  ROOFANGLE_25: string = `${this.assetsPath}${this.iconPath}Haus_25.png`;
  ROOFANGLE_30: string = `${this.assetsPath}${this.iconPath}Haus_30.png`;
  ROOFANGLE_35: string = `${this.assetsPath}${this.iconPath}Haus_35.png`;
  ROOFANGLE_40: string = `${this.assetsPath}${this.iconPath}Haus_40.png`;
  ROOFANGLE_45: string = `${this.assetsPath}${this.iconPath}Haus_45.png`;
  ROOFANGLE_50: string = `${this.assetsPath}${this.iconPath}Haus_50.png`;

  ROOF_PULT_64: string = `${this.assetsPath}${this.iconPath}pult64.png`;
  ROOF_SATTEL_64: string = `${this.assetsPath}${this.iconPath}sattel64.png`;
  ROOF_WALM_64: string = `${this.assetsPath}${this.iconPath}walm64.png`;
  ROOF_SCHED_64: string = `${this.assetsPath}${this.iconPath}sched64.png`;
  ROOF_KRUEPPEL_64: string = `${this.assetsPath}${this.iconPath}krueppelwalm64.png`;
  ROOF_MANSARD_64: string = `${this.assetsPath}${this.iconPath}mansard64.png`;


  ROOF_PULT: string = `${this.assetsPath}pult.png`;
  ROOF_SATTEL: string = `${this.assetsPath}sattel.png`;
  ROOF_WALM: string = `${this.assetsPath}walm.png`;
  ROOF_SCHED: string = `${this.assetsPath}sched.png`;
  ROOF_KRUEPPEL: string = `${this.assetsPath}krueppelwalm.png`;
  ROOF_MANSARD: string = `${this.assetsPath}mansard.png`;

  TRAPEZ_SHEET: string = `${this.assetsPath}trapez_sheet.png`;
  DISTANCE_INFO: string = `${this.assetsPath}abstand1sparren.png`;
  BEAM_DISTANCE_INFO: string = `${this.assetsPath}sparrenabstand.png`;

  //panel 
  ROOF_RANGE: string = `${this.assetsPath}roof_ranges.png`;
  REMOVE_PANEL_ICON1 = `${this.assetsPath}remove_selected_panels_icon_1.png`;
  REMOVE_PANEL_ICON2 = `${this.assetsPath}remove_all_eroded_icon_2.png`;
  REMOVE_PANEL_ICON3 = `${this.assetsPath}remove_all_panels_icon_3.png`;

  NONUSEAREA_CIRCLE = `${this.assetsPath}icon_builder_circle.png`;
  NONUSEAREA_TRIANGLE = `${this.assetsPath}icon_builder_triangle.png`;
  NONUSEAREA_SQUARE = `${this.assetsPath}icon_builder_square.png`;

  //inverters 
  MANUAL_DRAW = `${this.assetsPath}manual_draw.png`;
  AUTO_DRAW = `${this.assetsPath}icon_autodraw.png`;
  REMOVE_PANEL = `${this.assetsPath}icon_removepanel_all.png`;
  PLACE_CENTER = `${this.assetsPath}icon_center.png`;

  //common icons
  snowIcon: string = `${this.assetsPath}snowload_icon.png`;
  windIcon: string = `${this.assetsPath}windload_icon.png`;
  terrainIcon: string = `${this.assetsPath}terrain_icon.png`;
}
